module.exports = __webpack_public_path__ + "img/p3.b7a06f95.png";